// Wraps the hero + description + curriculum + portfolio sections alongside
// a sticky sidebar. The sidebar only sticks for as long as this shell is on
// screen — once the left column scrolls past the shell's bottom (right where
// the certificate section begins), it scrolls away with the rest of the page.
const CourseShell = ({ sidebar, children }) => (
  <div className="max-w-[1260px] mx-auto px-4 flex flex-col lg:flex-row gap-10 lg:gap-12 pb-10 lg:pb-14">
    <div className="min-w-0 lg:flex-1">{children}</div>

    <aside className="relative lg:w-course-sidebar lg:flex-none lg:pt-28">
      <div className="lg:sticky lg:top-20 space-y-4">{sidebar}</div>
    </aside>
  </div>
);

export default CourseShell;
